import React from 'react'

export default function SelectionToolIcon() {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="512.000000pt"
            height="512.000000pt"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
            className="svg-icon"
        >
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                stroke="none"
            >
                <path
                    d="M71 5102 c-69 -37 -71 -50 -71 -395 0 -347 2 -357 69 -395 35 -20 54
-22 186 -22 166 0 201 10 235 65 17 27 20 50 20 144 l0 111 111 0 c94 0 117 3
144 20 55 34 65 69 65 235 0 132 -2 151 -22 186 -38 67 -48 69 -395 69 -279 0
-311 -2 -342 -18z"
                />
                <path
                    d="M1380 5113 c-8 -3 -26 -15 -38 -27 -46 -41 -52 -66 -52 -221 0 -166
10 -201 65 -235 31 -19 49 -20 455 -20 406 0 424 1 455 20 55 34 65 69 65 235
0 157 -5 179 -55 225 l-27 25 -426 2 c-235 1 -434 -1 -442 -4z"
                />
                <path
                    d="M2880 5113 c-8 -3 -26 -15 -38 -27 -46 -41 -52 -66 -52 -221 0 -166
10 -201 65 -235 31 -19 49 -20 455 -20 406 0 424 1 455 20 55 34 65 69 65 235
0 157 -5 179 -55 225 l-27 25 -426 2 c-235 1 -434 -1 -442 -4z"
                />
                <path
                    d="M4364 5104 c-17 -8 -41 -32 -52 -53 -20 -35 -22 -54 -22 -186 0 -166
10 -201 65 -235 27 -17 50 -20 144 -20 l111 0 0 -111 c0 -94 3 -117 20 -144
34 -55 69 -65 235 -65 132 0 151 2 186 22 67 38 69 48 69 395 0 444 31 413
-415 413 -257 0 -315 -3 -341 -16z"
                />
                <path
                    d="M75 3811 c-16 -10 -39 -28 -50 -41 -19 -21 -20 -36 -20 -460 l0 -438
25 -27 c46 -50 68 -55 225 -55 166 0 201 10 235 65 19 31 20 49 20 455 0 406
-1 424 -20 455 -34 56 -69 65 -237 65 -127 0 -152 -3 -178 -19z"
                />
                <path
                    d="M4683 3814 c-18 -9 -42 -31 -53 -49 -19 -31 -20 -49 -20 -455 0 -406
1 -424 20 -455 34 -55 69 -65 235 -65 157 0 179 5 225 55 l25 27 0 438 0 438
-25 27 c-46 50 -68 55 -227 55 -115 0 -155 -4 -180 -16z"
                />
                <path
                    d="M75 2311 c-16 -10 -39 -28 -50 -41 -19 -21 -20 -36 -20 -460 l0 -438
25 -27 c46 -50 68 -55 225 -55 166 0 201 10 235 65 19 31 20 49 20 455 0 406
-1 424 -20 455 -34 56 -69 65 -237 65 -127 0 -152 -3 -178 -19z"
                />
                <path
                    d="M4683 2314 c-18 -9 -42 -31 -53 -49 -19 -31 -20 -49 -20 -455 0 -406
1 -424 20 -455 34 -55 69 -65 235 -65 157 0 179 5 225 55 l25 27 0 438 0 438
-25 27 c-46 50 -68 55 -227 55 -115 0 -155 -4 -180 -16z"
                />
                <path
                    d="M68 808 c-66 -38 -68 -49 -68 -395 0 -444 -31 -413 413 -413 347 0
357 2 395 69 20 35 22 54 22 186 0 166 -10 201 -65 235 -27 17 -50 20 -144 20
l-111 0 0 111 c0 94 -3 117 -20 144 -34 56 -69 65 -237 65 -133 0 -152 -3
-185 -22z"
                />
                <path
                    d="M4683 814 c-59 -29 -73 -66 -73 -193 l0 -111 -111 0 c-94 0 -117 -3
-144 -20 -55 -34 -65 -69 -65 -235 0 -132 2 -151 22 -186 38 -67 48 -69 395
-69 444 0 413 -31 413 413 0 347 -2 357 -69 395 -35 20 -53 22 -187 22 -116 0
-156 -4 -181 -16z"
                />
                <path
                    d="M1355 490 c-56 -37 -65 -68 -65 -233 0 -159 5 -181 55 -227 l27 -25
438 0 438 0 27 25 c50 46 55 68 55 225 0 166 -10 201 -65 235 -31 19 -49 20
-456 20 -405 0 -425 -1 -454 -20z"
                />
                <path
                    d="M2855 490 c-56 -37 -65 -68 -65 -233 0 -159 5 -181 55 -227 l27 -25
438 0 438 0 27 25 c50 46 55 68 55 225 0 166 -10 201 -65 235 -31 19 -49 20
-456 20 -405 0 -425 -1 -454 -20z"
                />
            </g>
        </svg>
    )
}
